export const optionsBeusType = [
  {
    value: 'NO_APPLIED',
    label: '적용하지 않음'
  },
  {
    value: 'STARTER',
    label: 'Starter',
  },
  {
    value: 'STARTER_PLUS',
    label: 'Starter+',
  },
  {
    value: 'BASIC',
    label: 'Basic',
  },
  {
    value: 'BASIC_PLUS',
    label: 'Basic+',
  },
  {
    value: 'LIGHT',
    label: 'Light',
  },
  {
    value: 'LIGHT_PLUS',
    label: 'Light+',
  },
  {
    value: 'STANDARD',
    label: 'Standard',
  },
  {
    value: 'STANDARD_PLUS',
    label: 'Standard+',
  },
  {
    value: 'PREMIUM',
    label: 'Premium',
  },
  {
    value: 'PREMIUM_PLUS',
    label: 'Premium+',
  },
  {
    value: 'PRO',
    label: 'Pro',
  },
  {
    value: 'PRO_PLUS',
    label: 'Pro+',
  },
  {
    value: 'SKT',
    label: 'SKT',
  }
]

export const optionsBiType = [
  {
    value: 'NO_APPLIED',
    label: '적용하지 않음'
  },
  {
    value: 'EVERYONE',
    label: 'Everyone',
  },
  {
    value: 'PRO',
    label: 'Pro',
  },
  {
    value: 'MASTER',
    label: 'Master',
  },
  {
    value: 'CUSTOM',
    label: 'Custom',
  },
  {
    value: 'AGENCY150',
    label: 'Agency150',
  },
  {
    value: 'AGENCY300',
    label: 'Agency300',
  },
  {
    value: 'EDU',
    label: 'Edu',
  }
]

export const optionsIssueEmail = [
  {
    value: 'tax',
    label: '세금 계산서 발행 이메일'
  },
  {
    value: 'manager',
    label: '담당자 이메일'
  },
  {
    value: 'system',
    label: '별도 시스템'
  }
] 

export const optionsTaxInfoType = [
  {
    value: 'EMAIL',
    label: '이메일'
  },
  {
    value: 'SYSTEM',
    label: '별도 시스템'
  }
] 